import { render, staticRenderFns } from "./FoodAdmin.vue?vue&type=template&id=58ba77ee"
import script from "./FoodAdmin.vue?vue&type=script&lang=js"
export * from "./FoodAdmin.vue?vue&type=script&lang=js"
import style0 from "./FoodAdmin.vue?vue&type=style&index=0&id=58ba77ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports